import { useEffect } from 'react';
import { useVisitorData } from '@fingerprint/react';
import { failFingerprint, setFingerprint } from '../api/fingerprint';
import { logError } from '../utils/logError';

const FingerprintBootstrap: React.FC = () => {
    const { data, error } = useVisitorData({ immediate: true });

    useEffect(() => {
        if (!data) return;
        const visitorId =
            (data as any).visitorId ?? (data as any).visitor_id ?? '';
        const requestId =
            (data as any).eventId ??
            (data as any).event_id ??
            (data as any).requestId ??
            (data as any).request_id ??
            '';
        if (visitorId) {
            setFingerprint({ visitorId, requestId });
        }
    }, [data]);

    useEffect(() => {
        if (!error) return;
        logError('Fingerprint bootstrap failed', { exception: error });
        failFingerprint(error);
    }, [error]);

    return null;
};

export default FingerprintBootstrap;
